<template>
    <div class="text-center ">
      <div class="">
        	<section class="profile w-100 section-padding">
                    <div class="">
                        <!-- <div class="picture-resume-wrapper">
                    <div class="picture-resume">
                    <span>
                        <img src="@/assets/4a.png" alt="" />
                    <img src="https://i.imgur.com/N4dRUx2.jpg" alt="" />
                    </span>        
                    </div>         
                </div>
                <div class="">
                    <h1>Jennifer <br/>Watson</h1>
                </div> -->
                <div class="">
            <div class="">
                <div class="header">
                   
                 <!--  <img src="@/assets/img/brasa.jpg" alt="Photo profile"> -->
                     <img :src="`${curriculo.photo ? curriculo.photo : avatar}`"  alt="Photo profile">
                   <!--  <img src="https://storage.alboom.ninja/sites/32632/albuns/698595/retratos_corporativos-6.JPG?t=1598278417" alt="Photo profile"> -->
                </div>
            
                <div class="description">
                <h2>{{curriculo.nome}} </h2>
                <h4>{{curriculo.titulo}}</h4>
                <h5>
               {{curriculo.expProfissional}}</h5>
                <!-- <div class="social">
                    <ul>
                    <li><a href="#"><i class="fa fa-eye"></i> 2482</a></li>
                    <li><a href="#"><i class="fa fa-heart color"></i> 1473</a></li>
                    <li><a href="#"><i class="fa fa-comment"></i> 642</a></li>
                    </ul>
                </div> -->
                </div>

                

            </div>
            </div>
                <div class="clearfix"></div>
                <div class="contact-info clearfix">
                    <ul class="list-titles">
                        <li><i class="fa fa-whatsapp mr-1"></i>Telefone</li>
                        <li><i class="fa fa-envelope-o mr-1"></i>E-mail</li>
                        <li><i class="fa fa-globe mr-1"></i>Cidade</li>
                    </ul>
                    <ul class="list-content ">
                       <li>{{curriculo.telefone}}</li> <!-- YOUR PHONE NUMBER  -->
                        <li>{{curriculo.email}}</li> <!-- YOUR EMAIL -->
                        <li>{{curriculo.localidade}}, {{curriculo.uf}}</li> <!-- YOUR STATE AND COUNTRY  -->
                    </ul>
                </div>
                <div class="contact-presentation"> <!-- YOUR PRESENTATION RESUME  -->
                    <p><span class="bold"></span>{{curriculo.objProfissional}}</p>
                </div>
                <div class="contact-social clearfix">
                    <ul class="list-titles">
                      <li v-if="curriculo.linkedin"><i class="fa fa-linkedin-square mr-1" aria-hidden="true"></i>Linkedin</li>
                      <li v-if="curriculo.github"><i class="fa fa-github mr-1" aria-hidden="true"></i>Github</li>
                      <li v-if="curriculo.facebook"><i class="fa fa-facebook-square mr-1" aria-hidden="true"></i>Facebook</li>
                      <li v-if="curriculo.instagram"><i class="fa fa-instagram mr-1" aria-hidden="true"></i>Instagram</li>
                    </ul>
                    <ul class="list-content"> <!-- REMEMBER TO PUT THE URL ON THE HREF TAG  -->
                      <li><a href="">{{curriculo.linkedin}}</a></li> <!-- YOUR TWITTER USER  -->
                      <li><a href="">{{curriculo.github}}</a></li> <!-- YOUR DRIBBBLE USER  -->
                      <li><a href="">{{curriculo.facebook}}</a></li> <!-- YOUR BEHANCE USER  -->
                      <li><a href="">{{curriculo.instagram}}</a></li> <!-- YOUR TWITTER USER  -->
                    </ul>
                </div>
                    </div>
                </section>
            
            <section v-if="curriculo.cadasExperiencia != '' " class="experience section-paddingg">
              <div class="container firsttop">
                <h3 class="experience-title">Experiência Profissional</h3>
                <div
                    v-for="(user, id) in curriculo.cadasExperiencia"
                    :key="id"
                  >
                <div class="experience-wrapper pt-4">
                  <div class="company-wrapper clearfix">
                    <div class="experience-title">{{user.nmEmpresa}}</div> <!-- NAME OF THE COMPANY YOUWORK WITH  -->
                    <div class="experience-title">{{user.cargo}}</div> <!-- JOB TITLE  -->
                  </div>
                </div>
                  
                  <div class="job-wrapper clearfix">
                    <div class="company-description">
                    <div class="time pb-2">{{user.mesInicio}}, {{user.anoInicio}} - {{user.box ? 'Presente' : `${user.mesTermino}, ${user.anoTermino}`}} <br>{{user.localidade}}</div> 
                      <p>{{user.description}}</p>  
                    </div>
                  </div>
                  </div><!--Skill experience-->

                    <!-- <div class="company-wrapper clearfix">
                    <div class="experience-title">Google</div> 
                    <div class="experience-title">Web Designer / Desenvolvedor Web</div> 
                  </div>
                  
                  <div class="job-wrapper clearfix">
                    <div class="company-description">
                    <div class="time pb-2">Nov 2012 - Presente <br>Timóteo, MG</div> 
                      <p>O que é uma experiência profissional? Uma experiência profissional é a vivência de um trabalho na prática. O termo costuma estar atrelado ao currículo, uma vez que o documento tem um campo destinado para a inserção do histórico de empregos. Ele deve conter o nome das empresas, os cargos, as atividades e os períodos trabalhados.</p>  
                    </div>
                  </div>


                    <div class="company-wrapper clearfix">
                    <div class="experience-title">Netflix</div> 
                    <div class="experience-title">Autônomo</div> 
                  </div>
                  
                  <div class="job-wrapperr clearfix">
                    <div class="company-description">
                    <div class="time pb-2">Nov 2012 - Presente <br>Timóteo, MG</div> 
                      <p>O que é uma experiência profissional? Uma experiência profissional é a vivência de um trabalho na prática. O termo costuma estar atrelado ao currículo, uma vez que o documento tem um campo destinado para a inserção do histórico de empregos. Ele deve conter o nome das empresas, os cargos, as atividades e os períodos trabalhados.</p>  
                    </div>
                  </div> --> 
                  
                <!--  <div class="company-wrapper clearfix">
                    <div class="experience-title">Google</div> 
                    <div class="time">Nov 2010 - Out 2012 <br>Timóteo, MG</div> 
                  </div>
                  
                  <div class="job-wrapper clearfix">
                    <div class="experience-title">Web Designer / Desenvolvedor Web </div> 
                    <div class="company-description">
                      <p>O que é uma experiência profissional? Uma experiência profissional é a vivência de um trabalho na prática. O termo costuma estar atrelado ao currículo, uma vez que o documento tem um campo destinado para a inserção do histórico de empregos. Ele deve conter o nome das empresas, os cargos, as atividades e os períodos trabalhados.</p>  
                    </div>
                  </div>
                  
                  <div class="company-wrapper clearfix">
                    <div class="experience-title">PayPal</div> 
                    <div class="time">Nov 2006 - Ago 2010 <br>Timóteo, MG</div> 
                  </div> 
                  
                  <div class="job-wrapper clearfix">
                    <div class="experience-title">Autônomo </div> 
                    <div class="company-description">
                      <p>O que é uma experiência profissional? Uma experiência profissional é a vivência de um trabalho na prática. O termo costuma estar atrelado ao currículo, uma vez que o documento tem um campo destinado para a inserção do histórico de empregos. Ele deve conter o nome das empresas, os cargos, as atividades e os períodos trabalhados.</p>   
                    </div>
                  </div> -->
                  
                
          </div>
        </section>
          
            
            <!--Skill Fomação Acadêmica-->
                    <section v-if="curriculo.academico != '' " class="experience section-paddingg">
                      <span class="text-white"> _______________ </span>
                      <div class="container mt-4">
                        <h3 class="experience-title">Formação Acadêmica</h3>
                        
                        <div class="experience-wrapper">             
                          <div
                            v-for="(user, id) in curriculo.academico"
                            :key="id"
                          >
                          <div class="job-wrapperr wd mt-1 ">
                            <div class="experience-title ">{{user.instituicao}}</div> <!-- JOB TITLE  -->
                            <div class="experience-title"></div> <!-- JOB TITLE  -->

                            <div class="company-description">
                              <p>{{user.diplomacao}} ({{user.anoInicio}} -  {{user.concluido ?  user.anoTermino : 'Presente'}})</p>  <!-- JOB DESCRIPTION  -->
                            </div>
                          </div>           
                          
                          <!-- <div class="mt-5">
                            <div class="experience-title ">Universidade Federal de Ouro Preto/UFOP  </div> 
                            <div class="experience-title"></div> 

                            <div class="company-description">
                              <p>Mestrado em Comércio Internacional. (Nov 2014 - Out 2016)</p>  
                            </div>
                          </div> -->
                          </div>
                          
                          
                          
                          
                          
                        </div><!--Skill Formação-->
                  <!-- YOUR SET OF SKILLS  -->
                  <!-- <div class="section-wrapper clearfix">
                    <h3 class="section-title">Skills</h3>  
                      <ul>
                        <li class="skill-percentage">HTML / HTML5</li>
                        <li class="skill-percentage">CSS / CSS3 / SASS / LESS</li>
                        <li class="skill-percentage">Javascript</li>
                        <li class="skill-percentage">Jquery</li>
                        <li class="skill-percentage">Wordpress</li>
                        <li class="skill-percentage">Photoshop</li>
                        
                      </ul>
                    
                  </div> -->
                  <!-- DESCRIPTION OF YOUR HOBBIES -->
                  <!-- <div class="section-wrapper clearfix">
                    <h3 class="section-title">Hobbies</h3>  
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a elit facilisis, adipiscing leo in, dignissim magna.</p>
                    
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a elit facilisis, adipiscing leo in, dignissim magna.</p> 
                  </div> -->
                  
                </div>
              </section>

            <section v-if="curriculo.cursos != '' " class="experience section-paddingg">
              <span class="text-white"> _______________ </span>

              


              <div class="container mt-4">
              <!-- YOUR SET OF SKILLS  -->
                  <div class="section-wrapper clearfix pb-3">
                    <h3 class="section-title">Cursos e Certificados</h3>  
                      <ul>
                        <li v-for="(data, id) in curriculo.cursos" :key="id">{{data.nome}}</li>
                        
                      </ul>
                    
                  </div>

                  </div>
            </section>


            <!--Skill Fomação Acadêmica-->
                    <section v-if="curriculo.referencia" class="experience section-paddingg">
                      <span class="text-white"> _______________ </span>

                      


                      <div class="container mt-4">
                      

                        
                        <h3 class="experience-title ">Referência</h3>
                        
                        <div class="experience-wrapper">       
                          <div class="job-wrapper wd mt-1 ">
                            <div class="experience-title ">{{curriculo.referencia}}</div> <!-- JOB TITLE  -->

                            <div class="company-description">
                              <!-- <p>Coordenador Administrativo  - Google</p> -->  
                            </div>
                                    
                          
                          <!-- <div class="mt-5">
                            <div class="experience-title ">Cicrano - (31) 9.9699-9999</div> 

                            <div class="company-description">
                              <p>Diretor de Operações - Nubank</p>  
                            </div>
                          </div>
                          



                          <div class="mt-5">
                            <div class="experience-title ">Beltrano - (31) 9.9699-9999</div> 

                            <div class="company-description">
                              <p>Gerente de Operacional - Nubank</p>  
                            </div>
                          </div> -->
                          </div>
                          
                          
                          
                          
                          
                        </div><!--Skill Formação-->
                  
                
                  
                </div>
              </section>
            
           
            </div>
    </div>
</template>

<script>
import firebase from 'firebase';
import avatar from "@/assets/img/avatar.svg"

export default {
    name: 'ThePDF',  
    data() {
        return {
            curriculo: {
              nome: "",
              telefone: "",
              email: "",
              localidade: "",
              uf: "",
              pcd: "Não",
              PcdDescricao: "",
              academico: [],
              titulo: "",
              cadasExperiencia: [],
              areasInteresse: [],
              informatica: [],
              expProfissional: "",
              objProfissional: "",
              cursos: [],
              referencia: "",
              linkedin: "",
              github: "",
              facebook: "",
              instagram: "",

              cpf: "",
              dataNasc: "",
              sexo: "Masculino",
              estadocivil: "Solteiro(a)",
              cep: "",
              logradouro: "",
              numero: "",
              complemento: "",
              bairro: "",
              cnh: "Não",
              escolaridade: "Ensino Fundamental Incompleto",
              profissoes: [],
              experiencia: "Sim",
              createdAt: ""
            },
            photo: "",
            nome: "",
            email: "",  
            avatar: avatar,       
            
            dados: "",
        }
    },
    /* async created() {
      await this.$store.commit('dados')
      console.log(this.$store.state.profile)

    }, */
    mounted() {
      const vm = this 

        firebase.auth().onAuthStateChanged((user) => {
      if (user) {        
        this.nome = user.displayName;
        this.email = user.email;
        this.emailVerificado = user.emailVerified;
      }
     })

     this.dados = JSON.parse(localStorage.getItem('curriculo'))

     /* let curriculo = "curriculo"

     

     
        
          var match = document.cookie.match(new RegExp('(^| )' + curriculo + '=([^;]+)'));
          if (match) {
          //  console.log(match[2]);

            this.dados = JSON.parse(match[2])

            console.log(this.dados)


          }
          else{
              console.log('--something went wrong---');
          }
 */
        if(this.dados) {
          const vm = this
            if (this.dados.nome) {
                        this.curriculo.nome = this.dados.nome 
                      }
                      if (this.dados.photo) {
                        this.curriculo.photo = this.dados.photo
                      }
                      if (this.dados.telefone) {
                        this.curriculo.telefone = this.dados.telefone  
                      }
                      if (this.dados.cpf) {
                        this.curriculo.cpf = this.dados.cpf 
                      }
                      if (this.dados.dataNasc) {
                        this.curriculo.dataNasc = this.dados.dataNasc 
                      }
                      if (this.dados.email) {
                        this.curriculo.email = this.dados.email 
                      }
                      if (this.dados.sexo) {
                        this.curriculo.sexo = this.dados.sexo  
                      }
                      if (this.dados.estadocivil) {
                        this.curriculo.estadocivil = this.dados.estadocivil  
                      }
                      if (this.dados.cep) {
                        this.curriculo.cep = this.dados.cep 
                      }
                      if (this.dados.logradouro) {
                        this.curriculo.logradouro = this.dados.logradouro  
                      }
                      if (this.dados.numero) {
                        this.curriculo.numero = this.dados.numero  
                      }
                      if (this.dados.complemento) {
                        this.curriculo.complemento = this.dados.complemento  
                      }
                      if (this.dados.bairro) {
                        this.curriculo.bairro = this.dados.bairro 
                      }
                      if (this.dados.localidade) {
                        this.curriculo.localidade = this.dados.localidade 
                      }
                      if (this.dados.uf) {
                        this.curriculo.uf = this.dados.uf
                      }
                      if (this.dados.cnh) {
                        this.curriculo.cnh = this.dados.cnh 
                      }
                      if (this.dados.pcd) {
                        this.curriculo.pcd = this.dados.pcd 
                      }
                      if (this.dados.PcdDescricao) {
                        this.curriculo.PcdDescricao = this.dados.PcdDescricao
                      }
                      if (this.dados.escolaridade) {
                        this.curriculo.escolaridade = this.dados.escolaridade  
                      }

                      if (this.dados.academico ) {
                        this.curriculo.academico = this.dados.academico 
                      }
                      if (this.dados.titulo) {
                        this.curriculo.titulo = this.dados.titulo 
                      }
                      if (this.dados.profissoes) {
                        this.curriculo.profissoes = this.dados.profissoes 
                      }
                      if (this.dados.experiencia) {
                        this.curriculo.experiencia = this.dados.experiencia 
                      }
                      if (this.dados.cadasExperiencia) {
                        this.curriculo.cadasExperiencia = this.dados.cadasExperiencia  
                      }
                      if (this.dados.areasInteresse) {
                        this.curriculo.areasInteresse = this.dados.areasInteresse 
                      }
                      if (this.dados.informatica) {
                        this.curriculo.informatica = this.dados.informatica 
                      }
                      if (this.dados.expProfissional) {
                        this.curriculo.expProfissional = this.dados.expProfissional  
                      }
                      if (this.dados.objProfissional) {
                        this.curriculo.objProfissional = this.dados.objProfissional 
                      }
                      if (this.dados.cursos) {
                        this.curriculo.cursos = this.dados.cursos 
                      }
                      if (this.dados.referencia) {
                        this.curriculo.referencia = this.dados.referencia 
                      }
                      if (this.dados.linkedin) {
                        this.curriculo.linkedin = this.dados.linkedin  
                      }
                      if (this.dados.github ) {
                        this.curriculo.github = this.dados.github 
                      }
                      if (this.dados.facebook) {
                        this.curriculo.facebook = this.dados.facebook 
                      }
                      if (this.dados.instagram) {
                        this.curriculo.instagram = this.dados.instagram 
                      } 
               } else {
                 return
               } 
      
    
      

   /*   var data = sessionStorage.getItem('curriculo')
      console.log(data) */
     

    //  console.log(this.$store.state.profile)

      

    // console.log(this.dataProfile)
      
    },
    
    methods: {
    
    }    

}
</script>

<style lang="scss" scoped>
.printpdf {
  z-index: 999999999;
}
@media print { 
  /* All your print styles go here */
  .printpdf { display: none !important; }

  .xpkprint { display: block !important; } 
  
 }

#jpdf {
    height: 11in;
    width: 8.5in;
}
.iconbar__container {
  display: flex;
  justify-content: center;
  color:#fff;
  fill: #fff;
   
    i {
     padding: 0px 12px 25px;
    
     fill: #fff;

    }
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}


@import url(https://fonts.googleapis.com/css?family=Varela+Round);
@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700);

$profileBg:#fff;
$skillsBg:#2d1cc4;
//$skillsBg:#3d3e42;
$profileColor:#9099a0;
$skillsColor:#9099a0; 
$linkColor:#66cc99;
$boldColor:#4a4e51;
$time:0.6s;

 
@mixin breakpoint($point) {
  @if $point == papa-bear {
    @media (max-width: 1500px)  { @content; }
  }
  @if $point == mama-bear {
    @media (max-width: 1200px)  { @content; }
  }
  @if $point == brother-bear {
    @media (max-width: 850px)  { @content; }
  }
  @else if $point == baby-bear {
    @media (max-width: 450px)  { @content; }
  }
}

*, *::after, *::before {
  box-sizing:border-box;
}

html,body {
  height: 100%;
}

body {
  font-family: 'Open Sans', sans-serif;
  font-size:16px;
  line-height:1.5em;
}
a{
  color:$linkColor; 
  text-decoration:none;
    .icon {
        color: rgb(19, 88, 214);  
        font: icon;      
      }

}
.clearfix::after, .clearfix::before {
  content: " ";
	display: table;
    
}
.clearfix::after{clear:both;}
.bold {color:$boldColor; font-weight:400;}

.resume-wrapper {
  position:relative;
  text-align:center;
  height:100%;
}



.profile {
  background:$profileBg;
  
  float:left;
  color:$profileColor;
  list-style-type:none;
  @include breakpoint(brother-bear) { width: 100%; }
  .name-wrapper {
    float:left;
    
  }
  h1 {
    font-size:2.5em;
    text-align:left;
    font-family: 'Varela Round', sans-serif;
    color:$boldColor;
    text-transform:uppercase;
    line-height:1em;
    padding-top:40px; 
    @include breakpoint(mama-bear) {
       padding-top:20px;
    }
    @include breakpoint(baby-bear) {
      font-size:1.8em;  
      padding-top:20px;
    } 
  }
  li {
      margin-bottom:10px;
    }
  .picture-resume-wrapper {
    width:40%;
    display:block;
    float:left;
    @include breakpoint(mama-bear) {
       width:100%;
    }
  }
  .picture-resume {
    width:220px;
    height:220px;
    background-size:cover;
    border-radius:50%;
    margin-right:0px;
    display:table;
    position:relative;
    vertical-align:middle;
    span {
        display:table-cell;
        vertical-align: middle;
        position:relative;
        margin:0 auto;
        z-index:10;
       text-align:center
    }
    img {
      border-radius:50%;
      width:130px;
      @include breakpoint(papa-bear) {
        width:100px;
      }
      @include breakpoint(mama-bear) {
        width:120px;
        height:120px;
      }
    }
    @include breakpoint(papa-bear) {
      width:150px;
      height:150px;
    }
    @include breakpoint(mama-bear) {
      width:200px;
      height:200px;
    }
     @include breakpoint(baby-bear) { width:180px;height:180px; } 
  }
  .contact-info{
    margin-top:50px;
    font-weight:300;
    
    @include breakpoint(mama-bear) {margin-top:40px; } 
    @include breakpoint(baby-bear) { margin-top:50px; } 
  }
  .list-titles {
    float:left;
    text-align:left;
    font-weight:600;
    width:40%;
    color:$boldColor;
    list-style-type:none;
    margin-left: 9%;
    @media(min-width: 600px) {
        margin-left: 14%;
      }
      @media(min-width: 800px) {
        margin-left: 21%;
      }
      @media(min-width: 1100px) {
        margin-left: 22%;
      }
  }

  .list-content{ 
    float:left;   
    text-align:left;
    font-weight:300;
    list-style-type:none;
  }
  .contact-presentation {
    font-weight:300;
    margin-top:100px;
    margin-bottom:100px;
    @include breakpoint(mama-bear) {margin-top:70px;margin-bottom:70px; } 
    @include breakpoint(brother-bear) {margin-top:50px;margin-bottom:50px; } 
    
  }
  svg {
    width:100%;
    position:absolute;
    top:0;
    left:0;
    //display:none;
  }

  .st0, .st1 {
    fill:#2d1cc4;
  }

}
.experience {
  background:$skillsBg;
  width:100%;
  float:left;
  position:relative;
  color:$skillsColor;
  font-weight:480;

  @include breakpoint(brother-bear) { width: 100%; } 
  h3.experience-title {
    color:$linkColor;
    text-align:left;
    text-transform:uppercase;
    font-size:1.2em;
    margin-bottom:20px;
    font-weight:400;
  }
  .company-wrapper {
    width:100%;
    float:left;
    text-align:left;
    padding-right:5%;
    margin-bottom:3px;
    @include breakpoint(baby-bear) {width:100%; margin-bottom:2px;} 
  }
  .job-wrapper {
    
    float:left;
    text-align:left;
    margin-bottom:60px;
    @include breakpoint(baby-bear) {width:100%;margin-bottom:40px;} 
  }

  .job-wrapperr {
    
    float:left;
    text-align:left;
    margin-bottom:30px;
    @include breakpoint(baby-bear) {width:100%;margin-bottom:40px;} 
  }

  .experience-title {
      color:white;
      margin-bottom:5px;;
    }
    .wd {
      width: 100%;
    }
}

.section-padding {
 padding:60px 60px 40px 40px;
 @include breakpoint(brother-bear) { padding:80px 15% 40px 10%; }
 @include breakpoint(baby-bear) { padding:40px 10% 20px 5%; }
}

.section-paddingg {
 padding:0px 60px 0px 40px;
 .firsttop{ 
    padding-top: 75px !important;
  }
}

.section-wrapper {
  width:100%;  
  float:left;
  text-align:left;
  color:$skillsColor;
  font-weight:300;
  margin-bottom:20px;
  @include breakpoint(baby-bear) {width:100%;}
  &:nth-child(3){ 
    padding-right:8%;
  }
  h3.section-title {
    color:$linkColor;
    text-align:left;
    text-transform:uppercase;
    font-size:1.2em;
    margin-bottom:20px;
    font-weight:400;
  }
  .skill-percentage {
    margin-bottom:10px;
    position:relative;
    &::after {
      content:"";
      width:100%;
      height:6px;
      background:$boldColor;
      display:block;
      margin-top:3px;
    }
    &::before{
      content:"";
      height:6px;
      background:$linkColor;
      position:absolute;
      margin-top:3px;
      bottom:0;
    }
    &:nth-child(1)::before {width:80%;animation: skill_1 $time ease;}
    &:nth-child(2)::before {width:90%; animation: skill_2 $time ease;} 
    &:nth-child(3)::before {width:50%;animation: skill_3 $time ease;}
    &:nth-child(4)::before {width:60%;animation: skill_4 $time ease;}
    &:nth-child(5)::before {width:70%;animation: skill_5 $time ease;}
    &:nth-child(6)::before {width:70%;animation: skill_6 $time ease;}
    &:nth-child(7)::before {width:70%;animation: skill_6 $time ease;}
  }
  
}

@keyframes skill_1 {from {width:0%;}to {width:80%;}}
@keyframes skill_2 {from {width:0%;}to {width:90%;}}
@keyframes skill_3 {from {width:0%;}to {width:50%;}}
@keyframes skill_4 {from {width:0%;}to {width:60%;}}
@keyframes skill_5 {from {width:0%;}to {width:70%;}}  
@keyframes skill_6 {from {width:0%;}to {width:70%;}}
@keyframes skill_7 {from {width:0%;}to {width:70%;}}




.card {
  display: flex;  
  height: auto;  
  background-color: $skillsBg;
  //background-color: #412977;
  border-radius: 10px;
  transition: .4s ease;
  box-shadow: 1px 1px 30px 1px rgba(0, 0, 0, 0.2);
  word-wrap: unset;
}


.header img {
  height: 150px;
  width: 150px;
  border: 15px solid $skillsBg;
  border: 15px solid #022797;
  border-radius: 50%;
  transition: .5s ease;
}

.header img:hover{
    height: 160px;
    width: 160px; 
    transition: .5s ease;
}

.header,
.description {
  padding: 20px 30px;
  text-align: right;
  direction: ltr;
    @media(max-width: 640px) {
        padding: 28px 30px;
    }
}

.description h2 {
  font-size: 20px;
}

.description h4 {
  font-size: 16px;
  margin-top: -5px;
  color: #b4b5be;
}

.description p {
  font-size: 14px;
  margin-top: 20px;
}

.description .social {
  margin-top: 30px;
}

.social ul {
  display: flex;
  list-style: none;
}

.description .social a {
  text-decoration: none;
  margin-left: 50px;
  color: #b4b5be;
}

.social .color {
  color: #ed1b73;
}

/* Responsive design */
@media (max-width: 640px) {
 

  .description h2 {
    margin-top: -35px;
  }

  .card .header,
  .description {
    text-align: center;
  }

  .social a {
    display: block;
    text-align: center;
  }
}



</style>
